<div>
  <slot></slot>
</div>

<style>
  div {
    margin: auto;
    max-width: min(80vw, 60rem);
  }
</style>